export default __webpack_public_path__ + "static/media/arrow-split-purple.f8ff7ad8.svg";